import React, { useState, useEffect } from 'react'
import { SYARAT_ZONA_KHAS, AMBANG_BATAS, PROSEDUR, STAGES } from './khasConstants'
import { penetapanApi } from './khasApi'
// ← EXISTING dan LS_DIREKTORI tidak diimport lagi

const HERO_BG = 'https://lh3.googleusercontent.com/aida-public/AB6AXuBXzMGImi4iZi7oXu23hV0WGTtDrAzxzdtDe2DsZdujWKZDHsfcYfD32GLLUs-0_OhYXXVOpIBlH8bla3fNRtmT7pXlSR_M9jEZ2ghOE4BtCiyQCkjAs72gZe6D0TODQokEZRAbJ-kD0vXAzBEw7A_X41I9ZgRonIabrCHrBb3EkrQtYH-z6yvRy1qzdCQdIfmAeXTKA_rQV_qkxMwZoP5X0fRbZ5X8oqRG0UGg56qgW3w8CwsleDYPmA'
const DOWNLOAD_BUKU_SAKU = '/assets/docs/Buku-Saku-Zona-KHAS.pdf'
const DOWNLOAD_POSTER    = '/assets/image/poster_zonakhas.jpeg'

function BerandaTab({ onGoTab }) {
  const [activeStage,   setActiveStage]   = useState(0)
  // ← state baru untuk data dari API
  const [zonaList,      setZonaList]      = useState([])

  // Fetch penetapan yang sudah dipublikasi
  useEffect(() => {
    penetapanApi.getPublik()
      .then(data => {
        const published = (data.penetapan || []).filter(pt => pt.dipublikasi === true)
        setZonaList(published)
      })
      .catch(err => console.error(err))
  }, [])

  const toggleStage = i => setActiveStage(prev => prev === i ? -1 : i)

  const heroBtnBase = {
    padding: '13px 28px', borderRadius: 10,
    fontSize: 14, fontWeight: 600, cursor: 'pointer',
    fontFamily: "'Poppins', sans-serif", letterSpacing: '0.02em',
    transition: 'all .2s', border: 'none',
    display: 'inline-flex', alignItems: 'center', gap: 8,
  }
  const dlBtnStyle = {
    background: 'rgba(255,255,255,0.12)',
    border: '1px solid rgba(255,255,255,0.3)',
    color: '#fff', padding: '8px 18px', borderRadius: 9,
    fontSize: 13, fontWeight: 600, cursor: 'pointer',
    fontFamily: "'Poppins', sans-serif",
    backdropFilter: 'blur(8px)',
    textDecoration: 'none',
    display: 'inline-flex', alignItems: 'center', gap: 6,
  }
  const IconDl = () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
      <polyline points="7 10 12 15 17 10"/>
      <line x1="12" y1="15" x2="12" y2="3"/>
    </svg>
  )

  return (
    <div style={{ width: '100%' }}>

      {/* ══════════════════════════════════════════════════════════
          HERO — background image dibagi 2 bagian:
          1. Centered content (min 80vh agar selalu kelihatan)
          2. Stats cards (selalu di bawah content, tidak pernah terpotong)
          ══════════════════════════════════════════════════════════ */}
      <div style={{
        position: 'relative', width: '100%',
        backgroundImage: `url(${HERO_BG})`,
        backgroundSize: 'cover', backgroundPosition: 'center',
      }}>
        {/* Gradient overlay — full area */}
        <div style={{
          position: 'absolute', inset: 0, zIndex: 0, pointerEvents: 'none',
          background: 'linear-gradient(to bottom, rgba(0,0,0,0.62) 0%, rgba(0,77,39,0.50) 100%)',
        }} />

        {/* ── Bagian 1: Centered hero content ── */}
        <div style={{
          position: 'relative', zIndex: 1,
          minHeight: '80vh',        // ← cukup untuk teks terpusat, tidak overflow ke stats
          display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center',
          textAlign: 'center',
          padding: 'clamp(80px,10vh,120px) clamp(20px,6%,80px) clamp(28px,4vh,44px)',
        }}>

          {/* Pill badge */}
          <span style={{
            display: 'inline-block', padding: '5px 18px', borderRadius: 99,
            background: 'rgba(0,77,39,0.78)', backdropFilter: 'blur(8px)',
            color: '#fff', fontSize: 12, fontWeight: 600, letterSpacing: '0.05em',
            marginBottom: 22, border: '1px solid rgba(255,255,255,0.22)',
          }}>
            Program Prioritas KNEKS · Ekonomi &amp; Keuangan Syariah
          </span>

          <h1 style={{
            fontSize: 'clamp(24px,4vw,46px)', fontWeight: 700, lineHeight: 1.1,
            letterSpacing: '-0.02em', color: '#fff',
            margin: '0 0 18px', maxWidth: 660,
          }}>
            Daftarkan kawasan kuliner Anda sebagai Zona KHAS
          </h1>

          <p style={{
            fontSize: 'clamp(14px,1.7vw,17px)', lineHeight: 1.65,
            color: 'rgba(255,255,255,0.9)', margin: '0 0 32px', maxWidth: 560,
          }}>
            Zona Kuliner Halal, Aman dan Sehat (Zona KHAS) adalah kawasan di mana semua pihak
            bekerja sama menyediakan makanan &amp; minuman yang{' '}
            <b>halal, sehat, dan aman</b> sesuai kaidah syariah.
          </p>

          {/* CTA buttons — dua-duanya borderRadius: 10 (konsisten) */}
          <div style={{ display:'flex', flexWrap:'wrap', justifyContent:'center', gap:12, marginBottom:28 }}>
            <button onClick={() => onGoTab('daftar')} style={{
              ...heroBtnBase, background:'var(--khas-primary)', color:'#fff',
              boxShadow:'0 4px 16px rgba(0,77,39,.4)',
            }}>
              Ajukan Zona KHAS
            </button>
            <button onClick={() => onGoTab('direktori')} style={{
              ...heroBtnBase,
              background:'rgba(255,255,255,0.14)', color:'#fff',
              border:'1.5px solid rgba(255,255,255,0.45)',
              backdropFilter:'blur(8px)',
            }}>
              Lihat Zona diresmikan
            </button>
          </div>

          {/* Download panduan */}
          <div style={{
            display:'flex', alignItems:'center', justifyContent:'center',
            gap:14, flexWrap:'wrap',
            paddingTop:20, borderTop:'1px solid rgba(255,255,255,0.18)',
          }}>
            <span style={{
              fontSize:13, fontWeight:600, color:'rgba(255,255,255,0.85)',
              display:'flex', alignItems:'center', gap:7,
            }}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
                <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
              </svg>
              Unduh Panduan:
            </span>
            <a href={DOWNLOAD_BUKU_SAKU} download="Buku-Saku-Zona-KHAS.pdf" style={dlBtnStyle}>
              <IconDl /> Buku Saku
            </a>
            <a href={DOWNLOAD_POSTER} download="Poster-Zona-KHAS.jpeg" style={dlBtnStyle}>
              <IconDl /> Poster
            </a>
          </div>
        </div>
      </div>

      {/* ══════════════════════════════════════════════════════════
          KONTEN BAWAH: Tahapan + Kriteria/Ambang/Prosedur
          ══════════════════════════════════════════════════════════ */}
      <div style={{ padding:'clamp(32px,4%,48px) clamp(20px,5%,64px) 80px' }}>

        {/* Tahapan — Horizontal stepper */}
          <div style={{
            background: 'rgba(255,255,255,0.75)',
            backdropFilter: 'blur(32px)', WebkitBackdropFilter: 'blur(32px)',
            border: '1px solid rgba(255,255,255,0.45)',
            borderRadius: 20, padding: 'clamp(22px,3%,36px)',
            boxShadow: '0 20px 40px -10px rgba(0,77,39,0.12)',
            marginBottom: 28,
          }}>
            {/* Header */}
            <div style={{ marginBottom: 24 }}>
              <h3 style={{ fontSize: 'clamp(17px,2.4vw,21px)', fontWeight: 700, color: '#191c1e', margin: '0 0 4px' }}>
                Tahapan pengajuan hingga penetapan
              </h3>
              <p style={{ margin: 0, fontSize: 13, color: 'var(--khas-muted)' }}>
                Klik setiap tahapan untuk melihat penjelasan
              </p>
            </div>

            {/* Horizontal stepper */}
            <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: activeStage >= 0 ? 20 : 0 }}>
              {STAGES.map((stage, i) => (
                <div key={i} onClick={() => toggleStage(i)}
                  style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer' }}>

                  {/* Baris: garis kiri — lingkaran — garis kanan */}
                  <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                    <div style={{
                      flex: 1, height: 2, borderRadius: 2,
                      background: i === 0 ? 'transparent' : 'var(--khas-border-l)',
                    }} />
                    <div style={{
                      width: 42, height: 42, borderRadius: '50%', flexShrink: 0,
                      background: activeStage === i ? 'var(--khas-green-d)' : 'var(--khas-surface-low)',
                      border: `2.5px solid ${activeStage === i ? 'var(--khas-green-d)' : 'var(--khas-border)'}`,
                      color: activeStage === i ? '#fff' : 'var(--khas-muted)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      fontWeight: 800, fontSize: 15,
                      boxShadow: activeStage === i ? '0 4px 14px rgba(0,77,39,.28)' : 'none',
                      transition: 'all .2s',
                    }}>
                      {i + 1}
                    </div>
                    <div style={{
                      flex: 1, height: 2, borderRadius: 2,
                      background: i === STAGES.length - 1 ? 'transparent' : 'var(--khas-border-l)',
                    }} />
                  </div>

                  {/* Label di bawah lingkaran */}
                  <div style={{
                    marginTop: 10, textAlign: 'center',
                    fontSize: 'clamp(10px,1.1vw,12px)', lineHeight: 1.35,
                    fontWeight: activeStage === i ? 700 : 500,
                    color: activeStage === i ? 'var(--khas-green-d)' : 'var(--khas-muted)',
                    padding: '0 4px', maxWidth: 110,
                    transition: 'color .2s',
                  }}>
                    {stage.b}
                  </div>
                </div>
              ))}
            </div>

            {/* Kotak deskripsi tahap aktif */}
            {activeStage >= 0 && (
              <div style={{
                background: 'var(--khas-green-l)', border: '1px solid #a7f3d0',
                borderRadius: 12, padding: '14px 20px',
                fontSize: 14, color: 'var(--khas-green-d)', lineHeight: 1.65,
              }}>
                <b>Tahap {activeStage + 1}: {STAGES[activeStage].b}</b><br />
                <span style={{ fontWeight: 400 }}>{STAGES[activeStage].s}</span>
              </div>
            )}
          </div>

        {/* Grid: 9 Syarat | Ambang Batas + Prosedur */}
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:24 }}>

          <div style={{ background:'#fff', borderRadius:20, padding:'clamp(20px,3%,32px)', boxShadow:'0 4px 16px rgba(0,77,39,0.07)', border:'1px solid rgba(190,201,190,0.4)' }}>
            <h3 style={{ fontSize:'clamp(16px,2vw,20px)', fontWeight:700, margin:'0 0 6px', color:'#191c1e' }}>9 Syarat Zona KHAS</h3>
            <p style={{ fontSize:14, color:'#6f7a70', margin:'0 0 18px' }}>Persyaratan yang wajib dipenuhi kawasan kuliner untuk menjadi Zona KHAS.</p>
            {SYARAT_ZONA_KHAS.map((c, i) => (
              <div key={i} className="khas-crit">
                <div className="khas-crit-num">{i+1}</div>
                <div><div className="khas-cb">{c.t}</div><div className="khas-cd">{c.d}</div></div>
              </div>
            ))}
          </div>

          <div style={{ display:'flex', flexDirection:'column', gap:24 }}>
            <div style={{ background:'#fff', borderRadius:20, padding:'clamp(20px,3%,32px)', boxShadow:'0 4px 16px rgba(0,77,39,0.07)', border:'1px solid rgba(190,201,190,0.4)' }}>
              <h3 style={{ fontSize:'clamp(16px,2vw,20px)', fontWeight:700, margin:'0 0 6px', color:'#191c1e' }}>Ambang Batas Penetapan</h3>
              <p style={{ fontSize:14, color:'#6f7a70', margin:'0 0 16px' }}>Persyaratan minimum untuk setiap tipe kawasan berdasarkan poster resmi KNEKS.</p>
              {AMBANG_BATAS.map((ab, i) => (
                <div key={i} style={{ background:'var(--khas-surface-low)', border:'1px solid var(--khas-border-l)', borderRadius:14, padding:'14px 18px', marginBottom:12 }}>
                  <div style={{ fontWeight:700, fontSize:14.5, color:'var(--khas-green-d)', marginBottom:10 }}>{ab.tipe}</div>
                  {[['Jumlah tenant',ab.tenant],['Sertifikat Halal',ab.halal],['SLHS / IKL',ab.sehat]].map(([l,v]) => (
                    <div key={l} style={{ display:'flex', justifyContent:'space-between', flexWrap:'wrap', gap:4, fontSize:13, padding:'5px 0', borderTop:'1px dashed var(--khas-border-l)' }}>
                      <span style={{ color:'var(--khas-muted)' }}>{l}</span>
                      <span style={{ fontWeight:600, color:'var(--khas-ink-2)', textAlign:'right' }}>{v}</span>
                    </div>
                  ))}
                </div>
              ))}
            </div>

            <div style={{ background:'#fff', borderRadius:20, padding:'clamp(20px,3%,32px)', boxShadow:'0 4px 16px rgba(0,77,39,0.07)', border:'1px solid rgba(190,201,190,0.4)' }}>
              <h3 style={{ fontSize:'clamp(16px,2vw,20px)', fontWeight:700, margin:'0 0 6px', color:'#191c1e' }}>Prosedur Penetapan</h3>
              <p style={{ fontSize:14, color:'#6f7a70', margin:'0 0 16px' }}>Langkah-langkah untuk mendapatkan penetapan Zona KHAS resmi.</p>
              {PROSEDUR.map((p, i) => (
                <div key={i} style={{ display:'flex', gap:14, alignItems:'flex-start', padding:'10px 0', borderBottom: i<PROSEDUR.length-1 ? '1px dashed var(--khas-border-l)' : 'none' }}>
                  <div style={{ width:26, height:26, borderRadius:'50%', flexShrink:0, background:'var(--khas-green-d)', color:'#fff', display:'flex', alignItems:'center', justifyContent:'center', fontWeight:700, fontSize:12 }}>
                    {i+1}
                  </div>
                  <span style={{ fontSize:14, color:'var(--khas-ink-2)', lineHeight:1.55 }}>{p}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <footer style={{ padding:'20px clamp(20px,5%,64px)', color:'var(--khas-muted)', fontSize:13, borderTop:'1px solid var(--khas-border-l)', background:'#fff', textAlign:'center' }}>
        Sistem pendaftaran <b>Zona KHAS</b> &mdash; Zona Kuliner Halal, Aman &amp; Sehat &nbsp;&middot;&nbsp; KNEKS 2026
      </footer>
    </div>
  )
}

export default BerandaTab